import { Pipe, PipeTransform } from "@angular/core";
import { KeycloakHelperService } from "@core/services";

@Pipe({
    name: "addCountryCode",
    standalone: false
})
export class AddCountryCodePipe implements PipeTransform {
  constructor(private keycloakHelperService: KeycloakHelperService) {}

  transform(value: string): string {
    if (value === null || value === undefined) {
      return value;
    }

    return `${value}-${this.keycloakHelperService
      .getUserCountryCode()
      .toLowerCase()}`;
  }
}
